// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as React from "react";
import * as ScoreSliderV2 from "./ScoreSliderV2.bs.js";
import * as ScoreCardFooter from "../common/ScoreCardFooter.bs.js";
import * as ScoreCardHeader from "../common/ScoreCardHeader.bs.js";
import * as ScoreMessageBoxV2 from "./ScoreMessageBoxV2.bs.js";
import * as SuspensionGuideCmp from "./SuspensionGuideCmp.bs.js";

function ScoreCardV2(Props) {
  var msisdn = Props.msisdn;
  var content = Props.content;
  var performance_score = Props.performance_score;
  return React.createElement("div", {
              className: "card-container"
            }, React.createElement(ScoreCardHeader.make, {
                  title_text: content.title_text,
                  msisdn: msisdn,
                  info_btn_details: content.info_btn_details
                }), React.createElement("div", {
                  className: "card-content-container"
                }, React.createElement(ScoreSliderV2.make, {
                      current_score: performance_score.value,
                      max_score: performance_score.max_score,
                      track_thresholds: $$Array.of_list(performance_score.track_thresholds),
                      action_details: performance_score.action_details
                    }), React.createElement(ScoreMessageBoxV2.make, {
                      message_box: performance_score.message_box,
                      max_score: performance_score.max_score,
                      action_details: performance_score.action_details
                    }), React.createElement(SuspensionGuideCmp.make, {
                      index: 1,
                      thresholds: performance_score.thresholds,
                      action_value: performance_score.action_value,
                      max_score: performance_score.max_score,
                      title_text: content.suspension_guide_text,
                      table_details: content.suspension_guide_table_details
                    })), React.createElement(ScoreCardFooter.make, {
                  msisdn: msisdn,
                  learn_more_text: content.learn_more_text,
                  learn_more_btn_details: content.learn_more_btn_details,
                  variant: /* V2 */1
                }));
}

var make = ScoreCardV2;

export {
  make ,
  
}
/* react Not a pure module */
